export const transformarUbigeo = (departamentos, provincias, distritos) => {
    const ubigeoMap = {};
  
    departamentos.forEach(dep => {
      ubigeoMap[dep.id_ubigeo] = { 
        nombre: dep.nombre_ubigeo, 
        provincias: {} 
      };
    });
  
    provincias.forEach(prov => {
      const idPadre = prov.id_padre_ubigeo;
      if (ubigeoMap[idPadre]) {
        ubigeoMap[idPadre].provincias[prov.id_ubigeo] = { 
          nombre: prov.nombre_ubigeo, 
          distritos: [] 
        };
      }
    });
  
    distritos.forEach(dist => {
      const idPadre = dist.id_padre_ubigeo;
      Object.values(ubigeoMap).forEach(dep => {
        if (dep.provincias[idPadre]) {
          dep.provincias[idPadre].distritos.push(dist.nombre_ubigeo);
        }
      });
    });
  
    return ubigeoMap;
  };  